import { Fragment } from 'react';

import { PlainDateSelector } from 'app/common/ui-next/plain-selector';
import PlainHelperText from 'app/common/ui-next/plain-helper-text';
import SubHeader from './SubHeader';


type Props = {
  orgIdFrom: number,
  loading: boolean,
  disabled: boolean,
  buildingId?: number
  error?: string,
  getDisabledDay: (day: string) => boolean,
  onDatesChange: (selection: Array<string>, selectionDateFormat: string) => void,
}

const CopyKitFormSameOrg = ({
  orgIdFrom: orgId,
  loading,
  disabled,
  buildingId,
  error,
  getDisabledDay,
  onDatesChange,
}: Props) => {
  return (
    <Fragment>
      <SubHeader>
        {'Выберите дату или даты в текущем заведении, на которую копировать комплект'}
      </SubHeader>

      <PlainDateSelector
        label="На дату"
        loading={loading}
        disabled={disabled}
        getDisabledDay={getDisabledDay}
        onChange={onDatesChange}
        multiple
      />

      {error
        && <PlainHelperText overflowVisible error>
          {error}
        </PlainHelperText>}
    </Fragment>
  );
};

export default CopyKitFormSameOrg;
